import styled from 'styled-components'
import { BlogThreshold as Threshold } from '../constants/theme'
import Colors from '../constants/colors'

export const AuthorInfo = styled.article`
  display: flex;
  align-items: center;
  margin: 0 10px;
  padding: 40px 29px 34px;
  border-radius: 10px;
  box-shadow: 0 2px 10px 0 rgba(192, 192, 192, 0.5);
  
  .avatar {
    width: 300px;
    height: 300px;
    margin-right: 50px;
    object-fit: cover;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 50%;
  }
  
  .authorInfo {
    min-height: 240px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  
  h1 {
    margin-bottom: 5px;
    text-transform: uppercase;
  }
  
  p {
    color: #000;
  }
  
  .links {
    margin-top: auto;
    margin-right: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .descriptionLink {
    display: block;
    color: ${Colors.primary}
  }
  
  @media (max-width: ${Threshold.tablet}) {
    padding: 25px 34px;
    margin: 0;
    
    .avatar {
      width: 150px;
      height: 150px;
      margin-right: 30px;
    }
    
    .authorInfo {
      min-height: 130px;
      
      ::before {
        content: '';
        background-color: ${Colors.primary};
        height: 2px;
        margin-bottom: 30px;
      }
    }
    
    p {
      font-size: 10px;
      line-height: 1.5;
      letter-spacing: 1px;
    }
    
    h1 {
      font-size: 25px;
      line-height: 1.2;
      letter-spacing: 1px;
    }
    
    .links {
      font-size: 12px;
      line-height: 1.5;
    }
  }
  
  @media (max-width: ${Threshold.phone}) {
    flex-direction: column;
    padding: 20px 7%;
    
    .avatar {
      width: 70px;
      height: 70px;
      margin: 0;
      margin-bottom: 12px;
    }
    
    .authorInfo {
      align-items: center;
      text-align: center;
      min-height: auto;
    
      ::before {
        width: 80%;
        margin-bottom: 13px;
      }
    }
    
    h1 {
      font-size: 20px;
      line-height: 1.5;
    }
    
    .links {
      justify-content: center;
    }
    
    .descriptionLink {
      margin: 5px 0;
    }
    
    .socials {
      margin-top: 5px;
    }
  }
`

export const Biography = styled.section`
  display: flex;
  align-items: baseline;
  margin-top: 60px;
  
  h2 {
    margin-right: 25px;
    margin-left: 40px;
    min-width: 227px;
    text-transform: uppercase;
  }
  
  .biographyText {
    max-width: 988px;
    
    p:first-child {
      margin-top: 0;
    }
  }
  
  @media (max-width: ${Threshold.tablet}) {
    margin-top: 30px;
    flex-direction: column;
    
    h2 {
      margin: 0;
      margin-bottom: 20px;
    }
    
    .biographyText {
      margin-bottom: 0;
    }
  }
  
  @media (max-width: ${Threshold.phone}) {
    margin-top: 20px;
    
    h2 {
      font-size: 14px;
      line-height: 1.57;
    }
    
    .biographyText {
      font-size: 14px;
      line-height: 1.57;
      margin-bottom: 20px;
    }
  }
`
